import { Helmet } from 'react-helmet-async';
import EditClinicTelecarePackageView from 'src/sections/clinic-dashboard/telepackages/telepackages-edit-view';

export default function ClinicEditTelecarePackagePage() {
  return (
    <>
      <Helmet>
        <title>Edit Telecare Package</title>
      </Helmet>

      <EditClinicTelecarePackageView />
    </>
  );
}
